import { createReducer, on } from '@ngrx/store';
import {
  deleteWorkspaceFailure,
  deleteWorkspaceSuccess,
  getWorkspacesFailure,
  getWorkspacesInvitesFailure,
  getWorkspacesInvitesSuccess,
  getWorkspacesRequest,
  getWorkspacesSuccess,
  updateWorkspacesInvitesSuccess,
  updateWorkspacesInvitesFailure,
  resetWorkspacesInvitesRequest,
} from './actions';
import { initialState } from './state';

export const workspacesReducer = createReducer(
  initialState,
  on(getWorkspacesRequest, (state) => {
    return {
      ...state,
      loading: true,
      error: null,
    };
  }),
  on(getWorkspacesSuccess, (state, { payload }) => ({ ...state, workspaces: payload, loading: false, isFirstLoad: false })),
  on(getWorkspacesFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error: error,
  })),

  on(getWorkspacesInvitesSuccess, (state, { payload }) => ({ ...state, workspacesInvites: payload, error: null })),
  on(getWorkspacesInvitesFailure, (state, { error }) => ({
    ...state,
    error: error,
  })),

  on(deleteWorkspaceSuccess, (state, workspaceId) => {
    const workspaces = state.workspaces.filter((item) => item.id !== workspaceId.workspaceId);
    return {
      ...state,
      workspaces,
    };
  }),
  on(deleteWorkspaceFailure, (state, { error }) => ({
    ...state,
    error: error,
  })),

  on(updateWorkspacesInvitesSuccess, (state, { payload }) => ({
    ...state,
    updateWorkspacesInvitesSuccess: payload,
    updateWorkspacesInvitesFailure: null,
  })),
  on(resetWorkspacesInvitesRequest, (state) => ({
    ...state,
    updateWorkspacesInvitesSuccess: null,
    updateWorkspacesInvitesFailure: null,
  })),
  on(updateWorkspacesInvitesFailure, (state, { error }) => ({
    ...state,
    updateWorkspacesInvitesSuccess: null,
    updateWorkspacesInvitesFailure: error,
  }))
);
